export const MEMBER_ROLES = [
  { id: "creator", label: "Criador de conteúdo" },
  { id: "member", label: "Membro" },
];

export const MEMBER_ROLE_LABEL = {
  owner: "Administrador",
  creator: "Criador de conteúdo",
  admin: "Administrador",
  member: "Membro",
};
